export const GEOXP_AUDIO_BUCKET = process.env.REACT_APP_AUDIO_BUCKET_NAME ?? 'geoxp-audio'

export const GEOXP_VIDEO_BUCKET = process.env.REACT_APP_VIDEO_BUCKET_NAME ?? 'geoxp-video'

export const CREDITS_ASSETS_BUCKET = process.env.REACT_APP_CREDITS_ASSETS_BUCKET_NAME ?? 'credits-assets'

export const GEOXP_SPOTS_TABLE = 'geoxp_spots'
export const SPOT_LOCALIZATIONS_TABLE = 'spot_localizations'

export const EXPERIENCE_CONTENT_TABLE = 'experience_content_spots'

export const AGAMI_GLOBAL_EXPERIENCE_ID = '679ec009-b360-40c3-bf21-ed49e4a7789c'

export const EXPERIENCES_TABLE = 'experiences'

export const USER_EXPERIENCES_TABLE = 'user_experiences'

export const PATTERNS_TABLE = 'patterns'

export const AGAMI_INDOOR_BUCKET = 'agami-indoor'

/**
 * Activation types (`spot_types`). The ids are the contract: `custom` (4) is the type
 * whose trigger the backend does not own — a word in the Onde cloud is activated by a
 * tap inside the app — and the config functions already emit an inert spot for it,
 * since position is produced only for type 1 and the code only for type 2.
 *
 * ⚠️ Not obtained from the lookup table: `getSpotTypes()` filters on
 * `is_active = true`, and that filter is exactly what keeps `custom` out of the v1
 * form. Code that needs the type knows it by constant.
 *
 * Twin of SPOT_TYPES in supabase/functions/_shared/constants.ts.
 */
export const SPOT_TYPES = {
  GEO: 1,
  MANUAL: 2,
  INDOOR: 3,
  CUSTOM: 4,
}

export const SPOT_MEDIA_TYPES = {
  AUDIO: 1,
  VIDEO: 2,
  NONE: 3,
} as const

/**
 * The activation types the v2 form offers (06.2), with the same labels the
 * lookup table carries (the selector capitalizes them for display).
 *
 * ⚠️ An application constant ON PURPOSE, not `getSpotTypes()`: that query
 * filters `is_active = true`, and the filter is exactly what keeps `custom`
 * out of the v1 form — adding an `includeInactive` parameter there would open
 * the door from the wrong side. `indoor` is deliberately absent: the product
 * retired it (inactive in the lookup, dedicated legacy view).
 */
export const V2_SPOT_TYPE_LABELS: Record<number, string> = {
  [SPOT_TYPES.GEO]: 'geo',
  [SPOT_TYPES.MANUAL]: 'manual',
  [SPOT_TYPES.CUSTOM]: 'custom',
}

/**
 * Outcomes of a draft submission (experience_draft_submissions.outcome).
 * Twin of the CHECK constraint on the satellite (05.1): three internal values,
 * no lookup table by design.
 */
export const SUBMISSION_OUTCOMES = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const
